import {
    FETCH_INVITATION_TPL,
    FETCH_INVITATION_TPLS,
} from '../actions/invitationTpl';


export const initialState = {
    isFetching: true,
    data: null
};

export const invitationTpls = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATION_TPLS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATION_TPLS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const invitationTpl = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATION_TPL}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATION_TPL}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/invitationTpl.js